/**
 * Название и подписи продукта — в одном месте.
 * Меняете здесь — меняется в приложении и в боте.
 * Заголовок вкладки браузера — в apps/web/index.html (<title>).
 */
export const BRAND = {
  /** Название продукта. */
  name: 'SHTURMAN Цех',
  /** Компания. */
  org: 'SHTURMAN',
  /** Короткое пояснение после названия. */
  tagline: 'помощник на производстве',
  /** Подпись кнопки, открывающей мини-приложение из бота (до ~20 символов). */
  openButton: 'Открыть приложение',
  /** Ник бота по умолчанию (настоящий — BOT_USERNAME в .env). */
  botUsername: 'shturman_ceh_bot',
} as const;
